<template>
  <div style="padding-top: 50px">
    <div>
      <p class="navadno-besedilo">
        Spodaj si lahko ogledate seznam pravic, ki so jih drugi uporabniki dodelili vam za svoje naročnine in
        priključke.
      </p>
    </div>
    <div>
      <div class="postavitev-info" v-for="pravica in dodeljenePraviceVpostopku">
        <div class="info-okvir" v-for="posamicnaPravica in pravica.dovoljenja">
          <div>
            <div class="posamezna-pravica-pad-bottom">
              <div class="postavitev-naziv-modro-okno-potrditev">
                {{pravica.uporabnik.ime || pravica.uporabnik.email}}
                te je povabil/a k soupravljanju naročnine <br/>
                (pravica: {{posamicnaPravica.naziv}}).
              </div>
              <div class="postavitev-gumbov-modro-okno-potrditev">
                <el-button
                    class="gumb-potrdi"
                    :disabled="posamicnaPravica.sprejemanje"
                    @click="ResponseNaDodeljenoPravico(posamicnaPravica.id, true, posamicnaPravica)">
                  <span v-if="!posamicnaPravica.sprejemanje">
                    SPREJMI
                  </span>
                  <span v-else>
                    V TEKU...
                  </span>
                </el-button>
                <a class="stil-gumb-preklici" type="primary"
                   @click="ResponseNaDodeljenoPravico(posamicnaPravica.id, false, posamicnaPravica)">
                  Zavrni
                </a>
              </div>
            </div>
            <div style="clear: both;"/>
          </div>
        </div>
      </div>
      <div style="padding-top: 50px" v-if="dodeljeneAktivnePravice.length > 0">
        <div>
          <div>
            <p class="open-sans-20pt pb-2">
              Seznam aktivnih pravic
            </p>
          </div>
        </div>
        <div v-if="prikazTabele === '1'">
          <el-table :data="dodeljeneAktivnePravice" v-loading="nalaganjePridobljenihPravic">
            <el-table-column prop="ime" label="Uporabnik" min-width="100px">
              <template slot-scope="scope">
                <div v-for="pravica in scope.row">
                  {{ pravica.email }}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="ime"
              label="Dodeljena pravica">
              <template slot-scope="scope">
                <div v-for="nazivPravice in scope.row.dovoljenja">
                  {{ nazivPravice.naziv }}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="ime"
              label="Nabor pravice">
              <template slot-scope="scope">
                <div v-for="naborPravice in scope.row.dovoljenja">
                  {{ naborPravice.scope }}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="ime"
              label="Dodeljena">
              <template slot-scope="scope">
                <div v-for="veljaOd in scope.row.dovoljenja">
                  {{ veljaOd.datumOd }}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="ime"
              label="Velja do">
              <template slot-scope="scope">
                <div v-for="veljaDo in scope.row.dovoljenja">
                <span v-if="veljaDo.datumDo === '01.01.2300 00:00:00'">
                  Do preklica
                </span>
                  <span v-else>
                  {{ veljaDo.datumDo }}
                </span>
                </div>
              </template>
            </el-table-column>
            <el-table-column min-width="50px" prop="ime" label="Status">
              <template slot-scope="scope">
                <div v-for="status in scope.row.dovoljenja">
                  Sprejeto
                </div>
              </template>
            </el-table-column>
            <el-table-column min-width="20px">
              <template slot-scope="scope">
                <div v-for="pravicaId in scope.row.dovoljenja">
                  <a style="cursor: pointer" @click="PreklicDodeljenePravice(pravicaId.id)">
                    <img src="/static/img/Naroci/Icon-awesome-trash-alt.svg">
                  </a>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div v-if="prikazTabele === '0'">
          <el-table
            :current-page='2' :page-size='1'
            :row-key="row => row.index"
            :expand-row-keys="expandRowKeysAktivnihPravic"
            :data="dodeljeneAktivnePravice">
            @expand-change="IzbiraVrsticeZaPrikazAktvinihPravic">
            <el-table-column
              prop="uporabnik.email"
              label="Email">
            </el-table-column>
            <el-table-column type="expand">
              <template slot-scope="scope">
                <div style="padding-top: 20px; padding-bottom: 20px">
                  <div v-for="pravica in scope.row">
                    <b>
                      Uporabnik:
                    </b>
                    <span>
                      {{ pravica.email }}
                    </span>
                  </div>
                  <div style="padding-top: 20px">
                    <div v-for="nazivPravice in scope.row.dovoljenja">
                      <hr/>
                      <div>
                        <b>
                          Dodeljenje pravice:
                        </b>
                        {{ nazivPravice.naziv }}
                      </div>
                      <div>
                        <b>
                          Nabor pravice:
                        </b>
                        {{ nazivPravice.scope }}
                      </div>
                      <div>
                        <b>
                          Dodeljena:
                        </b>
                        {{ nazivPravice.poslano }}
                      </div>
                      <div>
                        <b>
                          Velja do:
                        </b>
                        <span v-if="nazivPravice.poteceno === '01.01.2300 00:00:00'">
                          Do preklica
                        </span>
                        <span v-else>
                          {{ nazivPravice.poteceno }}
                        </span>
                      </div>
                      <div>
                        <b>
                          Status:
                        </b>
                        Sprejmi
                      </div>
                      <div>
                        <a style="cursor: pointer" @click="PreklicDodeljenePravice(nazivPravice.id)">
                          <img src="/static/img/Naroci/Icon-awesome-trash-alt.svg">
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <div style="padding-top: 30px" v-if="dodeljenePraviceVpostopku.length > 0">
        <div>
          <div>
            <p class="open-sans-20pt">
              Seznam pravic na čakanju
            </p>
          </div>
        </div>
        <div v-if="prikazTabele === '1'">
          <el-table
              :data="dodeljenePraviceVpostopku" v-loading="nalaganjePridobljenihPravic">
            <el-table-column prop="ime" label="Uporabnik" min-width="100px">
              <template slot-scope="scope">
                <div v-for="pravica in scope.row">
                  {{ pravica.email }}
                </div>
              </template>
            </el-table-column>
            <el-table-column
                prop="ime"
                label="Dodeljena pravica">
              <template slot-scope="scope">
                <div v-for="nazivPravice in scope.row.dovoljenja">
                  {{ nazivPravice.naziv }}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="ime"
              label="Nabor pravice">
              <template slot-scope="scope">
                <div v-for="naborPravice in scope.row.dovoljenja">
                  {{ naborPravice.scope }}
                </div>
              </template>
            </el-table-column>
            <el-table-column
                prop="ime"
                label="Dodeljena">
              <template slot-scope="scope">
                <div v-for="veljaOd in scope.row.dovoljenja">
                  {{ veljaOd.poslano }}
                </div>
              </template>
            </el-table-column>
            <el-table-column
                prop="ime"
                label="Velja do">
              <template slot-scope="scope">
                <div v-for="veljaDo in scope.row.dovoljenja">
                <span v-if="veljaDo.poteceno === '01.01.2300 00:00:00'">
                  Do preklica
                </span>
                  <span v-else>
                  {{ veljaDo.poteceno }}
                </span>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="ime" label="Status" min-width="50px">
              <template slot-scope="scope">
                <div v-for="status in scope.row.dovoljenja">
                  <span class="primarna-barva">
                    Sprejmi
                  </span>
                </div>
              </template>
            </el-table-column>
            <el-table-column min-width="20px">
              <template slot-scope="scope">
                <div v-for="pravicaId in scope.row.dovoljenja">
                  <a style="cursor: pointer" @click="PreklicDodeljenePravice(pravicaId.id)">
                    <img src="/static/img/Naroci/Icon-awesome-trash-alt.svg">
                  </a>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div v-if="prikazTabele === '0'">
          <el-table
            :current-page='2' :page-size='1'
            :row-key="row => row.index"
            :expand-row-keys="expandRowKeysNaCakanju"
            :data="dodeljenePraviceVpostopku">
            @expand-change="IzbiraVrsticeZaPrikazPodatkovNaCakanju">
            <el-table-column
              prop="uporabnik.email"
              label="Email">
            </el-table-column>
            <el-table-column type="expand">
              <template slot-scope="scope">
                <div style="padding-top: 20px; padding-bottom: 20px">
                  <div v-for="pravica in scope.row">
                    <b>
                      Uporabnik:
                    </b>
                    <span>
                      {{ pravica.email }}
                    </span>
                  </div>
                  <div style="padding-top: 20px">
                    <div v-for="nazivPravice in scope.row.dovoljenja">
                      <hr/>
                      <div>
                        <b>
                          Dodeljenje pravice:
                        </b>
                        {{ nazivPravice.naziv }}
                      </div>
                      <div>
                        <b>
                          Nabor pravice:
                        </b>
                        {{ nazivPravice.scope }}
                      </div>
                      <div>
                        <b>
                          Dodeljena:
                        </b>
                        {{ nazivPravice.poslano }}
                      </div>
                      <div>
                        <b>
                          Velja do:
                        </b>
                        <span v-if="nazivPravice.poteceno === '01.01.2300 00:00:00'">
                          Do preklica
                        </span>
                        <span v-else>
                          {{ nazivPravice.poteceno }}
                        </span>
                      </div>
                      <div>
                        <b>
                          Status:
                        </b>
                        Sprejmi
                      </div>
                      <div>
                        <a style="cursor: pointer" @click="PreklicDodeljenePravice(nazivPravice.id)">
                          <img src="/static/img/Naroci/Icon-awesome-trash-alt.svg">
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <div v-if="dodeljenePraviceNeaktivne.length > 0">
        <div style="padding-top: 50px">
          <div>
            <p class="open-sans-20pt">
              Seznam neaktivnih pravic
            </p>
          </div>
        </div>
        <div v-if="prikazTabele === '1'">
          <el-table :data="dodeljenePraviceNeaktivne">
            <el-table-column min-width="100px" prop="ime" label="Uporabnik">
              <template slot-scope="scope">
                <div v-for="pravica in scope.row">
                  {{ pravica.email }}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="ime"
              label="Dodeljena pravica">
              <template slot-scope="scope">
                <div v-for="nazivPravice in scope.row.dovoljenja">
                  {{ nazivPravice.naziv }}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="ime"
              label="Nabor pravice">
              <template slot-scope="scope">
                <div v-for="naborPravice in scope.row.dovoljenja">
                  {{ naborPravice.scope }}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="ime"
              label="Dodeljena">
              <template slot-scope="scope">
                <div v-for="veljaOd in scope.row.dovoljenja">
                  {{ veljaOd.datumOd }}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="ime"
              label="Velja do">
              <template slot-scope="scope">
                <div v-for="veljaDo in scope.row.dovoljenja">
                  <span v-if="veljaDo.datumDo === '01.01.2300 00:00:00'">
                    Do preklica
                  </span>
                  <span v-else>
                    {{ veljaDo.datumDo }}
                  </span>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="ime" label="Status" min-width="50px">
              <template slot-scope="scope">
                <div v-for="status in scope.row.dovoljenja">
                  Preklicano
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div v-if="prikazTabele === '0'">
          <el-table
            :current-page='2' :page-size='1'
            :row-key="row => row.index"
            :expand-row-keys="expandRowKeys"
            :data="dodeljenePraviceNeaktivne">
            @expand-change="IzbiraVrsticeZaPrikazPodatkovNeaktivne">
            <el-table-column
              prop="uporabnik.email"
              label="Email">
            </el-table-column>
            <el-table-column prop="uporabnik.email" label="Uporabnik" min-width="100px">
                <template slot-scope="scope">
                  <span>
                    {{ scope.row.uporabnik.ime}}
                  </span>
              </template>
            </el-table-column>
            <el-table-column type="expand">
              <template slot-scope="scope">
                <div style="padding-top: 20px; padding-bottom: 20px">
                  <p v-for="pravica in scope.row.dovoljenja" class="mobile-cell">
                  <span>
                    <b>
                      Pravica:
                    </b>
                    {{ pravica.naziv }}
                  </span>
                  <span>
                    <b>
                      Nabor pravice:
                    </b>
                    {{ pravica.scope }}
                  </span>
                  <span v-if="typeof pravica.datumOd !== 'undefined' && pravica.datumOd !== null">
                    <b>
                      Dodeljena:
                    </b>
                    {{ pravica.datumOd }}
                  </span>
                  <span v-if="typeof pravica.sprejeto !== 'undefined' && pravica.sprejeto !== null">
                    <b>
                      Sprejeto:
                    </b>
                    {{ pravica.sprejeto }}
                  </span>
                  <span v-if="typeof pravica.datumOd !== 'undefined' && pravica.datumOd !== null">
                    <b>
                      Velja od:
                    </b>
                    {{ pravica.datumOd }}
                  </span>
                  <span v-if="typeof pravica.poslano !== 'undefined' && pravica.poslano !== null">
                    <b>
                      Poslano:
                    </b>
                    {{ pravica.poslano }}
                  </span>
                  <span v-if="typeof pravica.poteceno !== 'undefined' && pravica.poteceno !== null">
                    <b>
                      Potečeno:
                    </b>
                    {{ pravica.poteceno }}
                  </span>
                  <span>
                    <b>
                      Status:
                    </b>
                    Preklicano
                  </span>
                </p>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  Button,
  Checkbox,
  Collapse,
  CollapseItem,
  Form,
  FormItem,
  Input, MessageBox,
  Option,
  Radio,
  Select,
  Divider,
  Table,
  TableColumn
} from 'element-ui'
import ClientAgent from '../../../../../assets/js/clientAgent'
import {VseDeljenePravice} from 'src/assets/js/globalne_funkcije/Pravice/VseDeljenePravice.js'
import Vue from 'vue'
import {SirinaOkna} from '../../../../../assets/js/globalne_funkcije/SirinaOkna'

export default {
  name: 'SprejetePravice',
  mixins: [VseDeljenePravice, SirinaOkna],
  data () {
    return {
      nalaganjePridobljenihPravic: true,
      dodeljenePraviceVpostopku: [],
      dodeljeneAktivnePravice: [],
      mejnaSirinaTabela: 1440,
      prikazTabele: '1',
      formaOrientacija: 'left',
      mejnaSirina: 360,
      dodeljenePraviceNeaktivne: [],
      expandRowKeys: [],
      expandRowKeysNaCakanju: [],
      expandRowKeysAktivnihPravic: []
    }
  },
  components: {
    'VseDeljenePravice': VseDeljenePravice,
    [Button.name]: Button,
    [Form.name]: Form,
    [Option.name]: Option,
    [Select.name]: Select,
    [FormItem.name]: FormItem,
    [Checkbox.name]: Checkbox,
    [Radio.name]: Radio,
    [Input.name]: Input,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Collapse.name]: Collapse,
    [CollapseItem.name]: CollapseItem,
    [Divider.name]: Divider
  },
  mounted () {
    this.clientAgent = new ClientAgent()
    this.GetDeljenePravice(true)
    this.$nextTick(function () {
      window.addEventListener('resize', this.SirinaOknaPresegaVrednostTabela)
      window.addEventListener('resize', this.SirinaOknaPresegaVrednost)
      window.dispatchEvent(new Event('resize'))
    })
  },
  methods: {
    IzbiraVrsticeZaPrikazPodatkovNeaktivne (row) {
      const id = row.index
      const lastId = this.expandRowKeys[0]
      this.expandRowKeys = id === lastId ? [] : [id]
    },
    IzbiraVrsticeZaPrikazPodatkovNaCakanju (row) {
      const id = row.index
      const lastId = this.expandRowKeysNaCakanju[0]
      this.expandRowKeysNaCakanju = id === lastId ? [] : [id]
    },
    IzbiraVrsticeZaPrikazAktvinihPravic (row) {
      const id = row.index
      const lastId = this.expandRowKeysAktivnihPravic[0]
      this.expandRowKeysAktivnihPravic = id === lastId ? [] : [id]
    },
    VseDeljenePravicePrenos (prenosniPodatki, nalaganje) {
      this.dodeljeneAktivnePravice = []
      this.dodeljenePraviceVpostopku = []
      this.dodeljenePraviceNeaktivne = []
      for (let i = 0; i < prenosniPodatki.data.active.length; i++) {
        this.dodeljeneAktivnePravice.push(prenosniPodatki.data.active[i])
      }
      for (let i = 0; i < prenosniPodatki.data.pending.length; i++) {
        this.dodeljenePraviceVpostopku.push(prenosniPodatki.data.pending[i])
      }
      if (typeof prenosniPodatki.data.inactive !== 'undefined') {
        for (let i = 0; i < prenosniPodatki.data.inactive.length; i++) {
          Vue.set(prenosniPodatki.data.inactive[i], 'index', i)
          let permissionsArray = []
          for (let j = 0; j < prenosniPodatki.data.inactive[i].dovoljenja.length; j++) {
            if (typeof prenosniPodatki.data.inactive[i].dovoljenja[j].sprejeto !== 'undefined' &&
              prenosniPodatki.data.inactive[i].dovoljenja[j].sprejeto !== null) {
              continue
            }
            if (typeof prenosniPodatki.data.inactive[i].dovoljenja[j].poslano !== 'undefined') {
              Vue.set(prenosniPodatki.data.inactive[i].dovoljenja[j], 'datumOd', prenosniPodatki.data.inactive[i].dovoljenja[j].poslano)
            }
            if (typeof prenosniPodatki.data.inactive[i].dovoljenja[j].poteceno !== 'undefined') {
              Vue.set(prenosniPodatki.data.inactive[i].dovoljenja[j], 'datumDo', prenosniPodatki.data.inactive[i].dovoljenja[j].poteceno)
            }
            permissionsArray.push(prenosniPodatki.data.inactive[i].dovoljenja[j])
          }
          if (permissionsArray.length > 0) {
            let permission = prenosniPodatki.data.inactive[i]
            permission.dovoljenja = permissionsArray
            this.dodeljenePraviceNeaktivne.push(permission)
          }
        }
      }
      this.nalaganjePridobljenihPravic = nalaganje
    },
    ResponseNaDodeljenoPravico (idPermissionGrantRequest, status, pravica) {
      let param = ['id=' + idPermissionGrantRequest]
      param.push('accept=' + status)
      Vue.set(pravica, 'sprejemanje', true)
      let prenosniParam = {sprejeta: status, pravica: pravica}
      this.clientAgent.postWsRequest(
        this,
        'permissions/respondPermissionGrant?',
        param,
        prenosniParam,
        'SetResponseNaDodeljenoPravico',
        'ErrResponseNaDodeljenoPravico')
    },
    SetResponseNaDodeljenoPravico (data, prenosniParam) {
      let paramObvestilo = {}
      paramObvestilo.message = 'Uspešno sprejeta pravica.'
      if (prenosniParam.sprejeta === false) {
        paramObvestilo.message = 'Uspešno preklicana pravica.'
      }
      this.ShowSuccessMessage(paramObvestilo)
      Vue.set(prenosniParam.pravica, 'sprejemanje', false)
      this.GetDeljenePravice(true)
      this.RefreshRoutesAndMenu()
    },
    ErrResponseNaDodeljenoPravico (podatki, prenosniParam) {
      let paramObvestilo = {}
      paramObvestilo.message = podatki.message
      this.ShowWarningMessage(paramObvestilo)
      Vue.set(prenosniParam.pravica, 'sprejemanje', false)
    },
    PreklicDodeljenePravice (idPermissionGrantRequest) {
      MessageBox.confirm(
        'Ali ste prepričani, da želite preklicati dodeljeno pravico?', {
          confirmButtonText: 'Da',
          cancelButtonText: 'Prekliči',
          confirmButtonClass: 'gumb-potrdi',
          cancelButtonClass: 'gumb-preklici',
          customClass: 'opozorilo-dialog'
        }).then(() => {
        let param = ['id=' + idPermissionGrantRequest]
        this.clientAgent.postWsRequest(this,
          'permissions/withdrawPermission?',
          param,
          null,
          'GetPreklicDodeljenePravice',
          'ErrPreklicDodeljenePravice')
      }).catch((err) => {
        err = null
      })
    },
    GetPreklicDodeljenePravice () {
      let paramObvestilo = {}
      paramObvestilo.message = 'Uspešno preklicana pravica.'
      this.ShowSuccessMessage(paramObvestilo)
      this.GetDeljenePravice(true)
      this.RefreshRoutesAndMenu()
    },
    ErrPreklicDodeljenePravice (podatki) {
      this.ShowWarningMessage(podatki)
    },
    RefreshRoutesAndMenu () {
      this.$emit('osveziMeni')
    }
  }
}
</script>

<style scoped>
.postavitev-naziv-modro-okno-potrditev {
  float: left;
}

.postavitev-gumbov-modro-okno-potrditev {
  float: right;
}

.info-okvir {
  width: 650px;
  height: 100%;
}

.gumb-potrdi {
  color: #e6f1fc !important;
  background-color: #409eff !important;
  border-color: #409eff !important;
}

.stil-gumb-preklici {
  color: #409eff !important;
}

.postavitev-naziv-modro-okno-potrditev {
  color: #409eff !important;
}

/deep/ .el-table .el-table__cell {
  vertical-align: baseline;
}

.postavitev-info {
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding-top: 20px;
}

@media only screen and (max-width: 1140px) {
  .postavitev-naziv-modro-okno-potrditev {
    max-width: 540px;
    float: none;
    padding-top: 10px;
  }

  .postavitev-gumbov-modro-okno-potrditev {
    padding-top: 20px;
    float: none;
  }

  .posamezna-pravica-pad-bottom {
    padding-bottom: 0;
  }
}

@media only screen and (max-width: 1440px) {
  .mobile-cell span{
    display: block !important;
  }

  .info-okvir {
    width: 100%;
    height: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/MojT2/UporabnikiInPravice/SprejetePravice.vue